var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('generic-update-list',_vm._b({attrs:{"custom-export-url":"/transports/export/"},scopedSlots:_vm._u([{key:"form",fn:function(ref){
var editedItem = ref.editedItem;
var error = ref.error;
return [_c('transport-form',_vm._b({},'transport-form',{ editedItem: editedItem, error: error, modelFk: _vm.modelFk },false))]}},{key:"item.start_date",fn:function(ref){
var item = ref.item;
return [_vm._v(" "+_vm._s(_vm.formatDate(item.start_date))+" ")]}},{key:"item.warnings",fn:function(ref){
var item = ref.item;
return [(item.warnings.length > 0)?_c('v-icon',[_vm._v(" fa fa-exclamation-triangle ")]):_vm._e()]}}])},'generic-update-list',{ model: _vm.model, modelHeaders: _vm.modelHeaders, modelFk: _vm.modelFk, defaultItem: _vm.defaultItem, filters: _vm.filters },false))}
var staticRenderFns = []

export { render, staticRenderFns }